import { User } from "../../shared/models/user.model";

export class TNCRequestPost {
  LocationId: number;
  RaisedBy: User;
  Status: string;
  CaseOwnerAppointment: User;
}

export class SubmitTorAction {
  Name: string = "Submit TOR";
  FileUrlTOR: any[] = []; // Document File
  DueDate: Date = new Date();
  Enabled: boolean = true;
  SelectedMarkAction: boolean = false;
  CaseOwnerActionId: number = 0;
}
export class SubmitDraftReportAction {
  Name: string = "Submit Draft Report";
  FileUrlDraft: any[] = []; // Document File
  DueDate: Date = new Date();
  Enabled: boolean;
  SelectedMarkAction: boolean = false;
  CaseOwnerActionId: number = 0;
}
export class SubmitInvestigationAction {
  Name: string = "Submit Final Investigation Report";
  FileUrlInvestigation: any[] = []; // Document File
  DueDate: Date = new Date();
  Enabled: boolean;
  SelectedMarkAction: boolean = false;
  CaseOwnerActionId: number = 0;
}

export class ActivityData {
  ActivityId: number;
  ActivityName: string;
  ActivityDescription: string;
  ActivityNumber: number;
}
